import { useEffect, useState } from "react";
import { CalendarDays } from "lucide-react";
import { EmployerLayout } from "@/components/employer/portal/EmployerLayout";
import { apiFetch, EmptyState, formatDate, Spinner, StatusPill } from "@/components/employer/portal/shared";

const nextStatuses = { scheduled: "completed", completed: "cancelled", cancelled: "scheduled" };

export default function EmployerInterviews() {
    const [items, setItems] = useState(null);

    const load = () => apiFetch("/employer/interviews").then((r) => (r.ok ? r.json() : [])).then(setItems);
    useEffect(() => {
        load();
    }, []);

    const cycle = async (item) => {
        const status = nextStatuses[item.status] || "scheduled";
        const res = await apiFetch(`/employer/interviews/${item.id}`, {
            method: "PATCH",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ status }),
        });
        if (res.ok) load();
    };

    return (
        <EmployerLayout title="Interviews" subtitle="Track interviews scheduled with candidates across your vacancies.">
            {!items ? <Spinner /> : items.length === 0 ? (
                <EmptyState title="No interviews scheduled" copy="Open an applicant and use Schedule Interview to add your first interview." />
            ) : (
                <div className="grid gap-px border border-ink/10 bg-ink/10 lg:grid-cols-2" data-testid="employer-interviews-list">
                    {items.map((item) => (
                        <article key={item.id} data-testid={`interview-${item.id}`} className="bg-ivory p-6">
                            <div className="flex items-start justify-between gap-5">
                                <div>
                                    <p className="flex items-center gap-2 text-[10px] font-semibold uppercase tracking-[0.2em] text-forest"><CalendarDays size={14} /> {formatDate(item.scheduled_at, true)}</p>
                                    <h2 className="mt-3 font-serif text-2xl font-medium tracking-tight">{item.candidate_name}</h2>
                                    <p className="mt-1 text-sm text-ink/55">{item.job_title}</p>
                                </div>
                                <StatusPill status={item.status} />
                            </div>
                            <div className="mt-5 space-y-2 text-sm text-ink/60">
                                <p>{item.mode}{item.location ? ` · ${item.location}` : ""}</p>
                                {item.notes && <p className="whitespace-pre-wrap">{item.notes}</p>}
                            </div>
                            <button type="button" data-testid={`interview-status-${item.id}`} onClick={() => cycle(item)} className="mt-5 border border-ink/20 px-4 py-2.5 text-[10px] font-semibold uppercase tracking-[0.14em] text-ink/60 transition-colors hover:border-forest hover:text-forest">
                                Mark {nextStatuses[item.status] || "scheduled"}
                            </button>
                        </article>
                    ))}
                </div>
            )}
        </EmployerLayout>
    );
}
